import { all } from 'redux-saga/effects';

export default function* startupSaga() {
  yield all([]);
}
